<template>
  <!-- eslint-disable max-len -->
  <v-card class="pa-4">
    <v-container>
      <v-form method="post" ref="formSkip" action="#" v-model="valid">
        <v-row>
          <v-col class="d-flex" cols="12">
            <span class="display-1 font-weight-light primary--text">{{skip.title}}</span>
          </v-col>
          <v-col class="d-flex" cols="12">
            <span class="font-weight-black">{{skip.text}}</span>
          </v-col>
          <v-col class="d-flex" cols="12">
            <span class="font-weight-black">{{skip.question}}</span>
          </v-col>
          <v-col class="d-flex " cols="12">
            <v-select :items="skip.options" v-model="skipReason"
                      :rules="[v => !!v || 'Please select reason']"
                      required outlined>  </v-select>
          </v-col>
        </v-row>
        <v-row v-if="isOtherSelected">
          <v-col class="d-flex" cols="12">
            <span class="font-weight-black">{{skip.verbatim.question}}</span>
          </v-col>
          <v-col class="d-flex" cols="12">
            <v-textarea outlined style="width:100%;"
                        v-model="verbatimResponse">
            </v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-card-actions>
      <v-btn class="font-weight-black submit"
             color="#7823dc" @click="skipSection()">Skip</v-btn>
      <v-btn color="darken-1" text @click="cancel()">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Skip',

  components: {
  },

  data: () => ({
    valid: true,
    isOtherSelected: false,
  }),

  props: ['skip', 'skipPopUpOpen', 'suffixKey', 'pageNr', 'isSummaryView'],

  computed: {
    ...mapGetters([
      'currentStep',
      'surveyFlow',
      'isSelfSurvey',
    ]),
    params() {
      return this.$store.state.params;
    },
    skipReason: {
      get() {
        return this.$store.state.response[`${this.skip.field}_${this.suffixKey}`];
      },
      set(newValue) {
        this.$store.commit('storeResponse', {
          k: `${this.skip.field}_${this.suffixKey}`,
          v: newValue,
        });

        this.isOtherSelected = newValue === 'Other';

        if (!this.isOtherSelected) {
          this.verbatimResponse = '';
        }
      },
    },
    verbatimResponse: {
      get() {
        return this.$store.state.response[`${this.skip.verbatim.field}_${this.suffixKey}`];
      },
      set(newValue) {
        this.$store.commit('storeResponse', {
          k: `${this.skip.verbatim.field}_${this.suffixKey}`,
          v: newValue,
        });
      },
    },
  },
  methods: {
    skipSection() {
      if (this.$refs.formSkip.validate()) {
        this.$emit('skipSection');
      }
    },
    cancel() {
      this.$emit('closeSkipPopUp');
    },
  },
};
</script>

<style scoped>

.submit {
  margin-bottom: 5px;
  border-color: #7823dc;
  color: white !important;
}
</style>
